import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { TopicPagePrefetchedDataProps } from 'src/app/pages/topic/pageContext';
import { prefetchPageContext, TopicPageContextProvider } from 'src/app/pages/topic/pageContext';

import { Layout } from '../layout';

import { TopicErrorHandler } from './ErrorHandler';

export const Topic = withPrefetchedData(
	function Topic({ prefetchedData }: TopicPagePrefetchedDataProps) {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<TopicPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={TopicErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</TopicPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
